import _ from 'lodash-es';
import { usePathname } from 'next/navigation';
import { useEffect, useMemo } from 'react';

import type { useClientApiV1SessionsQuery } from '../../resources/@types/accountSchema';
import { ApiError } from '../../resources/ApiError';
import useClientSessionQuery from '../queries/useClientV1SessionQuery';

export function useSession(options?: Parameters<typeof useClientApiV1SessionsQuery>[0]['options']) {
  const {
    data: session,
    isLoading: isSessionLoading,
    isError,
    error,
  } = useClientSessionQuery(options);

  const pathname = usePathname();

  useEffect(() => {
    if (isError && !ApiError.isApiError(error)) {
      console.error(
        `[ERROR - 세션 API 호출] pathname: ${pathname}, message: ${error instanceof Error ? error.message : error}`,
      );
    }
  }, [isError]);

  return useMemo(
    () => ({ isLogin: _.isNumber(session?.accountId), isSessionLoading }),
    [isSessionLoading, session?.accountId],
  );
}
